import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import cs from 'classnames';
import styles from './buttonToggle.module.scss';
/** Component to toggle between two states. */
export function ButtonToggle({ value, onChange, }) {
    return (_jsxs(FlexBox, Object.assign({ className: styles.group }, { children: [_jsx("button", Object.assign({ className: cs(styles.button, value === 'editor' && styles.selected), onClick: () => onChange('editor') }, { children: "Unpublished" })), _jsx("button", Object.assign({ className: cs(styles.button, value === 'saved' && styles.selected), onClick: () => onChange('saved') }, { children: "Published" }))] })));
}
